export default window.cms_googleanalytics = {
    title: "Google Analytics",
    key: "googleanalytics",
    category: "performance",
    activateCallback: function (props) {
        console.debug("CMS: googleanalytics - cookie activation callback with props [".concat(JSON.stringify(props), "]"));
        var gaScript = document.createElement('script');
        gaScript.async = true;
        gaScript.src = "https://www.googletagmanager.com/gtag/js?id=".concat(props.id);
        // Append the script to the document's head
        document.head.appendChild(gaScript);
        // Create another script to configure GA
        var gaConfigScript = document.createElement('script');
        gaConfigScript.innerHTML = "\n      window.dataLayer = window.dataLayer || [];\n      function gtag(){\n        dataLayer.push(arguments);\n      }\n      gtag('js', new Date());\n      gtag('config', '".concat(props.id, "');\n    ");
        // Append the configuration script to the document's head
        document.head.appendChild(gaConfigScript);
    },
    deactivateCallback: function (props) {
        console.debug("CMS: googleanalytics - cookie deactivation callback");
        var cookies = ['_ga', '_gid', '_gat', '__utma', '__utmb', '__utmc', '__utmt', '__utmz', '_gcl_au'];
        if (props && props.id) {
            var tagUaCookie = '_gat_gtag_' + props.id, tagGCookie = '_ga_' + props.id;
            tagUaCookie = tagUaCookie.replace(/-/g, '_');
            tagGCookie = tagGCookie.replace(/G-/g, '');
            cookies.push(tagUaCookie, tagGCookie);
        }
        cookies.forEach(function (name) {
            document.cookie = "".concat(name, "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=").concat(window.location.hostname);
        });
    },
};
